import { Injectable } from '@angular/core';
import { SnackBarService } from '@epicuro-next/ataraxia/snack-bar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import { showSnackBarMessage } from '../actions';

@Injectable()
export class SnackbarEffectsService {
  constructor(
    private snackbarService: SnackBarService,
    private actions$: Actions,
  ) {}

  public showMessage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(showSnackBarMessage),
        tap(({ message, messageType, position, actionName, hideDelay }) => {
          this.snackbarService.show(
            message,
            position,
            messageType,
            actionName,
            hideDelay,
          );
        }),
      ),
    { dispatch: false },
  );
}
